<template>
  <div class="">
<!--    max-height="600px"-->
    <el-table :data="pagingList"
              :header-cell-style="headerCellStyle"
              class="custom-delivery-table"
              max-height="calc(100vh - 200px)"
              size="small"
              v-loading="loadingList"
              border>
      <el-table-column label="起运地" width="80" prop="polCityName"/>
      <el-table-column label="直拼城市" width="80" prop="lineCityName">
        <template slot-scope="scope">
          {{ scope.row.priceType === 1 ? scope.row.polCityName : scope.row.lineCityName }}
        </template>
      </el-table-column>
      <el-table-column label="目的国" width="100" prop="countryName"/>
      <el-table-column label="产品名称" min-width="200" prop="productName"/>
      <el-table-column label="报价类型" width="145" prop="priceCode" :formatter="PriceTypeFormatter">
        <!-- <template slot-scope="scope">
          {{ scope.row.isFba ? "FBA报价" : "私人地址报价"}}
        </template> -->
      </el-table-column>
      <el-table-column label="参考时效" width="110" prop="aging"/>
      <el-table-column label="直拼价" width="200" prop="">
        <template slot-scope="scope">
          <img :src="ossPath + '/pages/queryPrice/vip_price_2.png'" alt="" style="vertical-align: -2px;" v-if="scope.row.priceHeaderRank === 2">
          <el-tooltip placement="bottom" effect="dark" popper-class="head-propper-tips" v-if="scope.row.isSegment">
            <div slot="content" style="width: 200px; font-size: 14px; line-height: 16px;">
              该报价为两段报价，显示的是到海外仓的价格，海外仓到目的地的派送价格请到方案详情查看。
            </div>
            <img style="width: 30px; vertical-align: -2px;" :src="ossPath + '/pages/home/head_line.png'" alt="">
          </el-tooltip>
          <template v-if="scope.row.subsidyPrice">
            <price-blurring
              class="color-primary"
              :price-display-type="scope.row.priceDisplayType"
              :currency="`优惠价:${scope.row.currency}`"
              :price="scope.row.subsidyPrice"
              inline
            />
            <br>
            <price-blurring
              class="origin-price"
              :price-display-type="scope.row.priceDisplayType"
              :currency="`原价:${scope.row.currency}`"
              :price="scope.row.priceinfo"
              inline
            />
          </template>
          <price-blurring
            v-else-if="scope.row.priceinfo || scope.row.priceinfo === 0"
            class="color-primary"
            :price-display-type="scope.row.priceDisplayType"
            :currency="scope.row.currency"
            :price="scope.row.priceinfo"
            inline
          />
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="转运价" width="120" prop="">
        <template slot-scope="scope">
          <price-blurring
            v-if="scope.row.transPriceInfo || scope.row.transPriceInfo === 0"
            class="color-primary"
            :price-display-type="scope.row.priceDisplayType"
            :currency="scope.row.transCurrency"
            :price="scope.row.transPriceInfo"
          />
          <span v-else>/</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="运费" width="180" prop="">
        <template slot-scope="scope">
          <price-blurring
            class="color-primary"
            :price-display-type="scope.row.priceDisplayType"
            :currency="scope.row.currency"
            :price="scope.row.priceinfo"
          />
        </template>
      </el-table-column> -->
      <el-table-column label="报价链接" width="80" fixed="right">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="clickItem(scope.row)">点击查价</el-link>
        </template>
      </el-table-column>
      <el-table-column label="产品培训视频" width="110" fixed="right">
        <template slot-scope="scope">
          <el-link v-if="scope.row.videoUrl" type="primary" :underline="false" @click="checkVideo(scope.row)">查看视频</el-link>
          <el-link v-else type="primary" :underline="false" :disabled="!scope.row.videoUrl">暂未上传视频</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list && list.length>pageSize"
      class="paging-row"
      style="margin-top: 15px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="totalListNum"
      background
    >
    </el-pagination>
  </div>
</template>

<script>

import {isArray} from "my-tools-kit";
import PriceBlurring from "../../../../../common/priceBlurring";
export default {
  name: "homeHotRecommendCountryProductList",
  components: {PriceBlurring},
  props:{
    list:{
      type:Array,
      required:true,
      default:()=>[],
    },
    headerCellStyle:{
      type:Object,
      default:()=>({ background: '#F3F3F3', color: '#999999' }),
    },
    // 正在加载城市
    loadingList:Boolean,
  },
  data(){
    return {
      /* 分页参数 */
      pageSizes: [12,20,30,40,50],
      pageSize: 12,
      currentPage: 1,
      videoVisible: false
    }
  },
  computed:{
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },
    clickItem(item){
      this.$emit("clickItem",item);
    },
    checkVideo(item) {
      this.$emit('checkVideo', item)
    },
    PriceTypeFormatter(val) {
      const code = val.priceCode
      let result = code
      switch (code) {
        case 'EC':
          result = 'FBA报价'
          break;
        case 'NON':
          result = '私人地址报价'
          break;
        case 'EC&NON':
          result = 'FBA&私人地址报价'
          break;
        default:
          break;
      }
      return result
    }
  },
}
</script>

<style scoped lang="less">
.custom-delivery-table{
  .origin-price{
    /deep/ .price-blurring--box{
      color: #999;
      text-decoration: line-through;
      .price-blurring--currency{
        font-size: 14px;
      }
      .price-blurring--price{
        font-size: 14px;
      }
      .price-blurring--unit{
        font-size: 14px
      }
    }
  }
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotRecommend/homeHotRecommendCountryProductList.vue